import { Component, inject, OnInit, signal, Input } from '@angular/core';
import { IndexIoService } from '../../../services/index-io.service';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { PerfRiskInfoResponseDto } from '../../../models/dto/perfriskinforesponse-dto';
import { PerformanceYearlyDto } from '../../../models/dto/performanceYearly-dto';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
  selector: 'bnpp-indx-index-perfriskinfo',
  imports: [NgIf, NgForOf, NgClass, ProgressSpinner],
  templateUrl: './index-perfriskinfo.component.html',
  styleUrl: './index-perfriskinfo.component.scss',
  standalone: true,
})
export class IndexPerfriskinfoComponent implements OnInit {
  private indexInfoService = inject(IndexIoService);
  @Input() mdsCode: string = '';

  indexHeaderInfo = this.indexInfoService.indexHeaderInfo;
  indexPerfRiskInfo = this.indexInfoService.indexPerfRiskInfo;

  currentStartIndex = signal(0);
  scrollAnnual(direction: number) {
    const total =
      this.indexPerfRiskInfo()?.[0]?.PerformanceYearly?.YearWiseData?.length ||
      0;

    const newIndex = this.currentStartIndex() + direction;
    if (newIndex >= 0 && newIndex + 4 <= total) {
      this.currentStartIndex.set(newIndex);
    }
  }

  public visibleYears(pr: PerfRiskInfoResponseDto): PerformanceYearlyDto[] {
    const all = pr?.PerformanceYearly.YearWiseData || [];
    return all.slice(this.currentStartIndex(), this.currentStartIndex() + 4);
  }

  ngOnInit(): void {
    this.indexInfoService.getIndexHeaderInfo(this.mdsCode);
    this.indexInfoService.getPerfRiskInfo(this.mdsCode);
  }

  getReturnClass(val: number, isLast?: boolean): string {
    let cssClass = '';
    if (val >= 0) cssClass = 'text-green-600 font-semibold';
    else if (val < 0) cssClass = 'text-red-600 font-semibold';
    else cssClass = 'text-gray-500';

    cssClass += isLast ? 'w-[9%]' : 'w-[14%]';
    return cssClass;
  }

  getSignedFormattedValue(value: number | null | undefined): string {
    const v = value ?? 0; // treat null/undefined as 0
    const sign = v > 0 ? '+' : ''; // add “+” only for positive numbers
    // keep two decimal places – the same format you use in the pipe
    const formatted = (v * 100).toFixed(2);
    return `${sign}${formatted}`;
  }

  getSignedValue(value: number | null | undefined): string {
    const v = value ?? 0; // treat null/undefined as 0
    const sign = v > 0 ? '+' : ''; // prepend '+' only for positives
    // keep exactly two decimals – equivalent to the number pipe you used before
    const formatted = v.toFixed(2);
    return `${sign}${formatted}`;
  }
}
